import { useQuery } from '@tanstack/react-query'

import { scenariosClient } from '@/api'

export const useScenarioResults = (scenarioId: number) => {
  const scenarioInfoQuery = useQuery({
    queryKey: scenariosClient.QUERY_KEY(scenarioId),
    queryFn: () => scenariosClient.getById(scenarioId),
    enabled: !!scenarioId
  })

  return {
    scenarioInfo: scenarioInfoQuery.data,
    isFetching: scenarioInfoQuery.isFetching
  }
}
